import { render } from "./VendasPeriodo.vue?vue&type=template&id=4ca04cf6&scoped=true"
import script from "./VendasPeriodo.vue?vue&type=script&lang=js"
export * from "./VendasPeriodo.vue?vue&type=script&lang=js"

import "./VendasPeriodo.vue?vue&type=style&index=0&id=4ca04cf6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca04cf6"]])

export default __exports__